import React from "react";
import { Form, withFormik } from "formik";
import { Row, Col } from "react-bootstrap";
import _ from "lodash";
import { DDadosTitle } from "@common/components/ddados";
import * as commonActionType from "@common/store/common/common.actionsType";
import Button from "@material-ui/core/Button";

class NestedForm extends React.Component {
  onKeyDownCapture(e) {
    if (e.key === "Enter") {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLSelectElement ||
        (e.target instanceof HTMLButtonElement && e.target.type !== "button")
      ) {
        e.preventDefault();
        this.props.onSubmit(e);
      }
    } else if (e.key === "Space") {
      this.checkForSubmitButton(e);
    }
  }

  checkForSubmitButton(e) {
    if (e.target instanceof HTMLButtonElement && e.target.type !== "button") {
      this.props.onSubmit(e);
    }
  }

  render() {
    const { onSubmit, ...props } = this.props;

    return (
      <div
        onKeyDownCapture={this.onKeyDownCapture.bind(this)}
        onClick={this.checkForSubmitButton.bind(this)}
        role="form"
        {...props}
      />
    );
  }
}

const FormComponent = ({ children, onSubmit, className, isSubForm }) => {
  const submitForm = e => {
    if (e.target.name != "filtro_form") {
      onSubmit(e);
    }
  };
  if (!isSubForm)
    return (
      <Form onSubmit={submitForm} className={className} noValidate>
        {children}
      </Form>
    );
  else
    return (
      <NestedForm className={className} onSubmit={onSubmit}>
        {children}
      </NestedForm>
    );
};

export { FormComponent };

class FormValidationExterno extends React.Component {
  constructor(props) {
    super();
    this.state = {
      values: undefined
    };
  }

  componentDidMount() {
    PubSub.subscribe(commonActionType.RESET_FORM, this.onResetForm.bind(this));
    PubSub.subscribe(
      commonActionType.SET_FIELD_VALUE,
      this.onSetFieldValue.bind(this)
    );
    let currentLocation;
    if (this.props.prefix) currentLocation = window.location.hash;
    window.isView = this.props.prefix === "V";
    window.prefix = this.props.prefix;

    if (this.props.formControl && !window.isView) {
      window._formControl = this.props.formControl;
      window.onbeforeunload = function (e) {
        return window.prefix ? "Há alterações não salvas." : undefined;
      };

      let { routerManager } = this.props;

      if (routerManager) {
        window.onpopstate = function (event) {
          let nextLocation = window.location.hash;
          history.pushState("", document.title, currentLocation);
          routerManager.redirect({
            url: nextLocation.substring(1)
          });
        };
      }
    }
  }

  // shouldComponentUpdate(nextProps) {
  //   return this.props.shouldUpdate || JSON.stringify(nextProps.values) != JSON.stringify(this.props.values);
  // }

  onSetFieldValue(act, values) {
    this.props.onChangeForm && this.props.onChangeForm(values);
  }

  onResetForm() {
    this.props.resetForm();
    PubSub.publish(commonActionType.RESET);
  }

  onCancel(prefix) {
    window.prefix = prefix;
    this.props.onCancel && this.props.onCancel();
  }

  renderButtons() {
    const {
      onCancel,
      onSubmit,
      onSubFormSubmit,
      onModalSubmit,
      isView,
      onPrint,
      notButton,
      onPrintReport,
      onValidate,
      onSearch,
      onSearchSubmit
    } = this.props;

    return (
      <>
        {!notButton && (
          <>
            {onSearch && (
              <Button
                className="ml-2 mr-2"
                variant="contained"
                size="large"
                color="primary"
                onClick={onSearch}
              >
                <i className="fas fa-search mr-1" /> Pesquisar
              </Button>
            )}
            {onPrint && (
              <Button
                variant="contained"
                size="large"
                style={{ marginRight: "8px" }}
                color="primary"
                className="ml-2"
                onClick={onPrint}
              >
                Imprimir Solicitação Completa
                <i className="fas fa-print ml-3"></i>
              </Button>
            )}
            {onCancel && (
              <Button
                variant="outlined"
                size="large"
                color="primary"
                onClick={onCancel}
              >
                <i
                  className={`mr-1 fa ${
                    isView ? "fa-angle-double-left" : "fa-ban"
                    }`}
                />{" "}
                {`${isView ? "Voltar" : "Cancelar"}`}
              </Button>
            )}
            {onSearchSubmit && (
              <Button
                className="ml-2 mr-2"
                type="submit"
                variant="contained"
                size="large"
                color="primary"
              >
                <i className="fas fa-search mr-1" /> Pesquisar
              </Button>
            )}
            {onSubmit && (
              <Button
                className="ml-2"
                type="submit"
                variant="contained"
                size="large"
                color="primary"
              >
                <i className="fas fa-check mr-1" /> Confirmar
              </Button>
            )}
            {onValidate && (
              <Button
                className="ml-2"
                type="submit"
                variant="contained"
                size="large"
                color="primary"
              >
                <i className="fas fa-check mr-1" /> Validar
              </Button>
            )}
            {onPrintReport && (
              <Button
                className="ml-2"
                type="submit"
                variant="contained"
                size="large"
                color="primary"
              >
                <i className="fas fa-print mr-1" /> Imprimir
              </Button>
            )}
            {onSubFormSubmit && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                <i className="fa fa-save" /> Salvar Sub
              </button>
            )}
            {onModalSubmit && (
              <button type="submit" className="btn btn-primary">
                <i className="fas fa-check" /> Confirmar
              </button>
            )}
          </>
        )}
      </>
    );
  }

  render() {
    const {
      className,
      onPrint,
      onCancel,
      onEdit,
      onSubmit,
      onExecute,
      onClear,
      onSubFormSubmit,
      onSubmitGeneric,
      onSubmitFilter,
      values,
      initialValues,
      notButton,
      onCancelVisible,
      prefix,
      title,
      boxForm,
      removeWell,
      onlyEdit,
      onModalSubmit,
      fromModal,
      onPrintReport,
      onValidate,
      onSearch,
      onSearchSubmit
    } = this.props;
    const { props } = this;

    const isView = prefix == "V";

    const { handleSubmit } = props;
    return (
      <Row>
        <Col>
          {title && <DDadosTitle prefix={prefix} title={title} />}
          <div className={boxForm && !removeWell ? "well" : ""}>
            <FormComponent
              onSubmit={e => {
                if (!fromModal)
                  setTimeout(() => {
                    if ($(".error > small").length > 0) {
                      $([document.documentElement, document.body]).animate(
                        {
                          scrollTop: $(".error > small").offset().top - 60
                        },
                        1000
                      );
                    }
                  });

                e.stopPropagation();
                handleSubmit(e);
              }}
              isSubForm={onSubFormSubmit || onSubmitFilter}
              className={`${className || ""} ${
                boxForm ? "box-form-cadastro" : ""
                }`}
              noValidate
            >
              {_.isFunction(this.props.children)
                ? this.props.children(props)
                : this.props.children}
              {!onSubmitFilter &&
                !onSubmitGeneric &&
                (onCancel ||
                  onSubmit ||
                  onSubFormSubmit ||
                  onModalSubmit ||
                  onExecute ||
                  onClear ||
                  onEdit ||
                  onPrint ||
                  onPrintReport ||
                  onValidate ||
                  onSearch ||
                  onSearchSubmit) &&
                !notButton && (
                  <>
                    {!fromModal && (
                      <Row>
                        <Col
                          className={`${
                            !onSubmitFilter ? "text-right mt-4" : ""
                            }`}
                        >
                          {this.renderButtons()}
                        </Col>
                      </Row>
                    )}

                    {fromModal && (
                      <Col>
                        <div
                          className={`${!onSubmitFilter ? "text-right" : ""}`}
                        >
                          {this.renderButtons()}
                        </div>
                      </Col>
                    )}
                  </>
                )}
            </FormComponent>
          </div>
        </Col>
      </Row>
    );
  }
}

const EnhancedForm = withFormik({
  mapPropsToValues: props => props.initialValues || {},
  handleSubmit: (values, form) => {
    const {
      onSubmit,
      onExecute,
      onSubFormSubmit,
      onSubmitFilter,
      onSubmitGeneric,
      onModalSubmit,
      onEdit,
      onPrint,
      onPrintReport,
      onValidate,
      onSearch,
      onSearchSubmit
    } = form.props;
    const onSubmitFormComponent =
      onSubmit ||
      onSubFormSubmit ||
      onModalSubmit ||
      onSubmitGeneric ||
      onSubmitFilter ||
      onExecute ||
      onEdit ||
      onPrint ||
      onPrintReport ||
      onValidate ||
      onSearch ||
      onSearchSubmit;
    onSubmitFormComponent && onSubmitFormComponent(values, form);
  },
  validateOnChange: true,
  validateOnBlur: true,
  displayName: "BasicForm"
})(FormValidationExterno);

export default EnhancedForm;
